/* ============================================================
   LEOSPORTZ — theme-search.js
   Search overlay / predictive search.
   ============================================================ */

(function () {
'use strict';

window.Leosportz = window.Leosportz || {};
const { $, $$, on, debounce } = Leosportz.utils;

Leosportz.Search = {
  init() {
    const toggles = $$('[data-search-toggle]');
    const pwaSearchBtns = $$('[data-pwa-search-open]');
    const overlay = $('.search-overlay');
    const input = $('.search-overlay__input');
    const closeBtn = $('.search-overlay__close');
    if (!overlay) return;

    const open = () => { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; input?.focus(); };
    const close = () => { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };

    toggles.forEach(t => {
      on(t, 'focus', open);
      on(t, 'click', open);
    });
    pwaSearchBtns.forEach(b => on(b, 'click', open));
    if (closeBtn) on(closeBtn, 'click', close);
    on(overlay, 'click', e => { if (e.target === overlay) close(); });
    on(document, 'keydown', e => { if (e.key === 'Escape') close(); });

    // Predictive search
    if (input) {
      on(input, 'input', debounce(async () => {
        const q = input.value.trim();
        const resultsEl = $('.search-overlay__results');
        if (!q || !resultsEl) { resultsEl.innerHTML = ''; return; }

        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product`);
          const data = await res.json();
          const products = data.resources?.results?.products || [];
          if (products.length === 0) {
            resultsEl.innerHTML = '<div class="search-overlay__empty">No products found.</div>';
          } else {
            resultsEl.innerHTML = products.map(p => `
              <a href="${p.url}" class="search-overlay__result">
                <img src="${p.image}" alt="${p.title}" loading="lazy">
                <span>${p.title}</span>
              </a>
            `).join('');
          }
        } catch (err) {
          console.error('Search failed:', err);
        }
      }, 300));
    }
  },
};

})();
